import { Badge } from "types/badge";
import { BadgeCriteriaType } from "helpers/constants";

/**
 * Check if a user should receive badges based on their feedback count
 * @param feedbackCount - Total number of feedbacks given/requested
 * @param existingBadges - Array of badge names the user already has
 * @param availableBadges - Array of badges from database with matching criteria_type
 * @param criteriaType - Type of criteria to check
 * @returns Array of eligible badge names
 */
export const checkBadgeEligibility = (
  feedbackCount: number,
  existingBadges: string[],
  availableBadges: Badge[],
  criteriaType: BadgeCriteriaType = BadgeCriteriaType.FEEDBACK_COUNT
): string[] => {
  if (!availableBadges || availableBadges.length === 0) {
    return [];
  }

  // Filter badges by criteria_type and sort by criteria_value (ascending - lowest first)
  // This ensures we award all badges the user qualifies for
  const relevantBadges = availableBadges
    .filter((badge) => badge.criteria_type === criteriaType)
    .sort((a, b) => (a.criteria_value || 0) - (b.criteria_value || 0));

  console.log("Badge eligibility check:", {
    criteriaType,
    feedbackCount,
    existingBadges,
    relevantBadges: relevantBadges.map((b) => ({ name: b.name, value: b.criteria_value })),
  });

  // Find all badges the user qualifies for that they don't already have
  const eligibleBadgeNames: string[] = [];
  for (const badge of relevantBadges) {
    if (
      feedbackCount >= badge.criteria_value &&
      !existingBadges.includes(badge.name)
    ) {
      console.log("Eligible badge found:", badge.name);
      eligibleBadgeNames.push(badge.name);
    }
  }

  return eligibleBadgeNames;
};

/**
 * Get badge by name from badges array
 */
export const getBadgeByName = (
  badges: Badge[],
  badgeName: string
): Badge | null => {
  return badges.find((b) => b.name === badgeName) || null;
};
